import { Model, Attr } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'

@Model()
export default class SorewardsCard extends ApplicationRecord {
  static jsonapiType = 'sorewards_cards'
  static endpoint = '/sorewards_card'
  static singularResource = true

  @Attr({ persist: false }) sorewardsCardId!: string
  @Attr({ persist: false }) sorewardsBeneficiaryId!: string
  @Attr({ persist: false }) mobile!: string
  @Attr({ persist: false }) birthdate!: string
  @Attr({ persist: false }) createdAt!: string
  @Attr({ persist: false }) updatedAt!: string
}
